// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Billboard-module__container___qiDQZ {
    position: relative;
    display: inline-block;
    height: auto;
    width: 100%; /* Make width responsive */
    max-width: 815px; 
    aspect-ratio: 815/510;

    transform: perspective(2000px);
    transition: all 0.3s ease;
    /* Add depth to the whole panel */
    filter: 
        drop-shadow(-8px 8px 4px rgba(0, 0, 0, 0.15)) 
        drop-shadow(-15px 15px 10px rgba(0, 0, 0, 0.12)) 
        drop-shadow(-2px 2px 2px rgba(0, 0, 0, 0.1));
}

.Billboard-module__backgroundImage___yFxQa {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;

    background: linear-gradient(
        105deg,
        rgba(255, 255, 255, 0.2) 0%,
        rgba(255, 255, 255, 0) 40%
    );
}

.Billboard-module__overlayImage___q0ELX, .Billboard-module__overlayVideo___DlZHO {    
    position: absolute;
    top: 8.3%;
    left: 3.2%;
    width: 93.8%;
    height: 83.5%;
    object-fit: cover;
}

`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Panels/Billboard/Billboard.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,WAAW,EAAE,0BAA0B;IACvC,gBAAgB;IAChB,qBAAqB;;IAErB,8BAA8B;IAC9B,yBAAyB;IACzB,iCAAiC;IACjC;;;oDAGgD;AACpD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB;;;;KAIC;AACL;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB","sourcesContent":[".container {\n    position: relative;\n    display: inline-block;\n    height: auto;\n    width: 100%; /* Make width responsive */\n    max-width: 815px; \n    aspect-ratio: 815/510;\n\n    transform: perspective(2000px);\n    transition: all 0.3s ease;\n    /* Add depth to the whole panel */\n    filter: \n        drop-shadow(-8px 8px 4px rgba(0, 0, 0, 0.15)) \n        drop-shadow(-15px 15px 10px rgba(0, 0, 0, 0.12)) \n        drop-shadow(-2px 2px 2px rgba(0, 0, 0, 0.1));\n}\n\n.backgroundImage {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n\n    background: linear-gradient(\n        105deg,\n        rgba(255, 255, 255, 0.2) 0%,\n        rgba(255, 255, 255, 0) 40%\n    );\n}\n\n.overlayImage, .overlayVideo {    \n    position: absolute;\n    top: 8.3%;\n    left: 3.2%;\n    width: 93.8%;\n    height: 83.5%;\n    object-fit: cover;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Billboard-module__container___qiDQZ`,
	"backgroundImage": `Billboard-module__backgroundImage___yFxQa`,
	"overlayImage": `Billboard-module__overlayImage___q0ELX`,
	"overlayVideo": `Billboard-module__overlayVideo___DlZHO`
};
export default ___CSS_LOADER_EXPORT___;
